module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-2-c842c8ff65f1b9ac4cd78b48f4e6cff6.png";